import { useMemo, useState } from "react";

import Modal from "../../../../components/portal/Modal";

import StageSidebar from "./StageSidebar";
import StageDetails from "./StageDetails";
import { stages } from "../../utils/jobcardStages";

export default function JobCardViewDialog({ data, closeDialog }) {
  const [activeStageId, setActiveStageId] = useState(1);

  const stageMap = useMemo(() => {
    return data.stageUpdates.reduce((acc, stage) => {
      acc[stage.stageId] = stage;
      return acc;
    }, {});
  }, [data.stageUpdates]);

  const activeStageData = stageMap[activeStageId];

  return (
    <Modal
      onClose={closeDialog}
      modalWidth="max-w-7xl w-11/12 2xs:max-sm:w-95% 2xs:max-md:px-4 2xs:max-md:py-4 pb-8 pt-6 px-6"
      closeIcon
    >
      <div className="flex gap-6 mt-6 rounded-xl max-h-[900px] max-lg:text-xs">
        <StageSidebar
          stages={stages}
          stageMap={stageMap}
          activeStageId={activeStageId}
          onStageChange={setActiveStageId}
        />

        <StageDetails
          stage={stages[activeStageId - 1]}
          stageData={activeStageData}
        />
      </div>
    </Modal>
  );
}
